<template>
  <div class="main-container expiry" role="alert" ref="expiryContainer">
    <div class="col-12 expiry-content-holder">
      <div class="expiry-content-flex">
        <div class="expiry-title">This solicitation has ended.</div>
        <div class="expiry-content">
          The period for submitting pass-through voting requests has officially concluded, so no further entries will be
          accepted.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Expiry",
  props: {
    expiry: Object,
  },
};
</script>

<style lang="scss">
.main-container {
  &.expiry {
    padding: 40px;
    background: var(--backgroundAccent);

    @include media-breakpoint-down(md) {
      padding: 30px;
    }
  }
}

.expiry-content-flex {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}

.expiry-content-holder {
  display: flex;
  flex-direction: column;
  row-gap: 30px;

  button {
    @include round-btn();
    margin-top: 10px;
  }
}

.expiry-title {
  font-size: 40px;
  line-height: 150%;
  font-weight: 700;
  color: var(--primaryText);
  font-family: var(--micrositeTypeStyle);

  p {
    font-size: inherit;
    line-height: inherit;
    margin: 0;
  }
}

.expiry-content {
  font-size: 15px;
  line-height: 150%;
  color: var(--primaryText);
  font-family: var(--micrositeTypeStyle);

  p {
    margin: 0;
  }
}
</style>
